const themeStyles = () => ({
  scrollPaper: {
    alignItems: 'flex-start',

  },
  paper: {
    margin: '2rem 1rem',
    width: 'calc(100% - 2rem)',
  },
  subjectWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: 'calc(100% - 40px)',
  },
  subject: {
    fontSize: '1.125rem',
    minHeight: '1.75rem',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '13rem',
    '&:hover': {
      width: 'auto',
    },
  },
});

export default themeStyles;
